import * as yup from 'yup';
import config from "../../config/config.json";

/**
 * @returns {Object}
 */
export default (currentProgram, programs, countries, locations) =>  {

    const maxFileSize = config?.max_file_size ?? 10;
    const maxTotalSize = config?.max_total_size ?? 20;
    const allowedFileTypes = config?.allowed_tile_types ?? ["application/pdf"]
    const minResumesRequired = currentProgram?.bezeichnung == "Senior Business Coach" ? 1 : 0;

    return yup.object().shape({
        attachments: yup.object().shape({
            resume: yup.array()
              .of(
                yup.object().shape({
                  file: yup.mixed()
                    .required('Die Datei darf nicht leer sein'),
                  fileType: yup.string()
                    .oneOf(allowedFileTypes, 'Die Datei muss eine PDF sein')
                    .required('Der Dateityp ist erforderlich'),
                  fileSize: yup.number()
                    .max(maxFileSize * 1024 * 1024, `Die Datei darf nicht größer als ${maxFileSize} MB sein`)
                    .required('Dateigröße ist erforderlich'),
                })
              )
              .min(minResumesRequired, 'Der Lebenslauf ist erforderlich')
              .nullable(),
            grades: yup.array()
              .of(
                yup.object().shape({
                  file: yup.mixed()
                    .required('Die Datei darf nicht leer sein'),
                  fileType: yup.string()
                    .oneOf(allowedFileTypes, 'Die Datei muss eine PDF sein')
                    .required('Der Dateityp ist erforderlich'),
                  fileSize: yup.number()
                    .max(maxFileSize * 1024 * 1024, `Die Datei darf nicht größer als ${maxFileSize} MB sein`)
                    .required('Dateigröße ist erforderlich'),
                })
              )
              .nullable(),
            miscellaneous: yup.array()
              .of(
                yup.object().shape({
                  file: yup.mixed()
                    .required('Die Datei darf nicht leer sein'),
                  fileType: yup.string()
                    .oneOf(allowedFileTypes, 'Die Datei muss eine PDF sein')
                    .required('Der Dateityp ist erforderlich'),
                  fileSize: yup.number()
                    .max(maxFileSize * 1024 * 1024, `Die Datei darf nicht größer als ${maxFileSize} MB sein`)
                    .required('Dateigröße ist erforderlich'),
                })
              )
              .nullable(),
          }).test(
            'total-size',
            `Die Gesamtgröße der Dateien darf nicht größer als ${maxTotalSize} MB sein`,
            (attachments) => {
                if (!attachments) return true;

                const totalSize = ['resume', 'grades', 'miscellaneous']
                    .flatMap(category => attachments[category] || [])
                    .reduce((sum, fileObj) => sum + (fileObj?.fileSize || 0), 0);

                return totalSize <= maxTotalSize * 1024 * 1024;
            }
        ),
        general: yup.object().shape({
            accepted: yup
                .boolean()
                .default(false)
                .oneOf([true])
                .required(),
        }),
        contract: yup.object().shape({
            accepted: yup
                .boolean()
                .default(false)
                .oneOf([true])
                .required(),
        }),
        privacyPolicy: yup.object().shape({
            accepted: yup
                .boolean()
                .default(false)
                .oneOf([true])
                .required(),
        })
    });
}
